import React from "react"
import Text from "@/components/common/Text"
import Audio from "@/components/common/Audio"

const AudioDescription = ({ data, desc, color }) => {
	const audioUrl = data?.audio?.source?.url || ""
	const title = data?.audio?.source?.title || ""
	return (
		<>
			<Text tag="div" className="typo-borna typo-borna-11 description" color={color} dangerouslySetInnerHTML={desc} />
			<Audio url={audioUrl} title={title} />
		</>
	)
}

export default AudioDescription
